import styled from "styled-components";
import { FONTS } from "../../../shared";
import { MEDIA_QUERY } from "../../../entities/Common";

export const CheckoutListStyled = styled.div`
  ul {
    list-style: none;
    padding: 0;
  }
  li {
    display: flex;
    align-items: center;
    margin-bottom: 0px;
    &:last-child {
      margin-bottom: 0;
    }
    span {
      font-size: 25px;
      &:nth-child(2) {
        margin-left: 10px;
        font-weight: ${FONTS.FONT_WEIGHT_BOLD};
      }
    }
  }
  @media (max-width: ${MEDIA_QUERY.MONITOR}) {
    li {
      span {
        font-size: 20px;
      }
    }
  }

  @media (max-width: ${MEDIA_QUERY.LAPTOP}) {
    li {
      span {
        font-size: 16px;
      }
    }
  }

  @media (max-width: ${MEDIA_QUERY.MOBILE}) {
    li {
      span {
        font-size: 14px;
      }
    }
  }
`;

export const CheckoutListSkeletonStyled = styled.ul`
  list-style-type: none;
  padding: 0;
  margin-bottom: 20px;
  li {
    margin-bottom: 5px;
    &:last-child {
      margin-bottom: 0;
    }
  }
`;
